export const userRols = {
  company_admin: "Admin",
  company_regular_user: "Regular user",
};
export const COMPANY_ADMIN_ROLE = "company_admin";
